import React, {useContext, useMemo} from 'react';
import {useMedia} from 'react-use';
import {
  selectAvailableRoleNames,
  selectLocalPeerID,
  selectLocalPeerRoleName,
  selectPermissions,
  useHMSActions,
  useHMSStore,
} from '@100mslive/react-sdk';
import {ArrowRightIcon, CheckIcon, PersonIcon} from '@100mslive/react-icons';
import {Dropdown, Text, config} from '@100mslive/roomkit-react';

import {AppContext} from '../context/AppContext';
// import {ToastManager} from '../Toast/ToastManager';
import {arrayIntersection} from '../common/utils';

export const ChangeSelfRole = ({css, onClick}: any) => {
  const roles = useHMSStore(selectAvailableRoleNames);
  const permissions = useHMSStore(selectPermissions);
  const localPeerId = useHMSStore(selectLocalPeerID);
  const localPeerRole = useHMSStore(selectLocalPeerRoleName);
  const hmsActions = useHMSActions();
  const hideTriggerItem = useMedia(config.media.sm);
  const {
    appPolicyConfig: {selfRoleChangeTo},
  } = useContext(AppContext);

  const availableSelfChangeRoles = useMemo(
    () => arrayIntersection(selfRoleChangeTo, roles),
    [roles, selfRoleChangeTo]
  );

  if (!permissions?.changeRole) {
    return null;
  }
  return hideTriggerItem ? (
    <Dropdown.Item onClick={onClick}>
      <PersonIcon />
      <Text variant="sm" css={{ mx: "$4", fontWeight:600 }}>
        Change My Role
      </Text>
    </Dropdown.Item>
  ) : (
    <Dropdown.SubMenu>
      <Dropdown.TriggerItem data-testid="change_my_role_btn">
        <PersonIcon />
        <Text variant="sm" css={{  mx: "$4", fontWeight:600 }}>
          Change My Role
        </Text>
      </Dropdown.TriggerItem>
      <Dropdown.SubMenuContent
        sideOffset={8}
        alignOffset={-5}
        css={{
          backgroundColor: "$surface_default",
          "@md": { w: "$64" },
        }}
      >
        {availableSelfChangeRoles.map((role: any,index:any) => (
          <Dropdown.Item
            key={role}
            css={{
              justifyContent: "space-between",
              "&:hover": { backgroundColor: "$surface_bright" },
            }}
            onClick={async () => {
              try {
                await hmsActions.changeRole(localPeerId, role, true);
              } catch (error) {
                // ToastManager.addToast({ title: error.message });
              }
            }}
            data-testid={"change_to_role_" + role}
          >
            <Text variant="sm">{role}</Text>
            {localPeerRole === role && <CheckIcon width={16} height={16} />}
          </Dropdown.Item>
        ))}
      </Dropdown.SubMenuContent>
    </Dropdown.SubMenu>
  );
};
